module.exports = __webpack_public_path__ + "img/vol05_cup02_label02.79e3b10d.png";